<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="1000px" transition="dialog-bottom-transition">

      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-6">
                <v-combobox         
                  v-if="!isClient"         
                  v-model="item.client"
                  name="client"
                  item-title="name"
                  item-value="id"
                  :items="clients"
                  label="Cliente*"
                  autocomplete="off"
                  :disabled="disabled || disableClientField"
                  :rules="[rules.requiredComboBox]"
                  clearable
                ></v-combobox>

                <v-text-field label="Nombre*" name="name" v-model="item.name" :disabled="disabled" :rules="[rules.required]"></v-text-field>

       
                <v-text-field 
                  label="Dirección*" 
                  v-model="item.address" 
                  :disabled="disabled" 
                  :rules="[rules.required]"
                  @blur="onInputBlur"
                ></v-text-field>


                <v-text-field 
                  label="Referencia de Dirección" 
                  v-model="item.reference" 
                  :disabled="disabled" 
                  @blur="onInputBlur"
                ></v-text-field>

                <v-text-field 
                  label="Referencia Externa" 
                  v-model="item.external_reference" 
                  :disabled="disabled"
                ></v-text-field>

                <v-text-field 
                  label="Localidad*" 
                  v-model="item.location" 
                  :disabled="disabled" 
                  :rules="[rules.required]"
                  @blur="onInputBlur"
                ></v-text-field>
              
                <v-text-field 
                  label="Código Postal*" 
                  v-model="item.postal_code" 
                  :disabled="disabled" 
                  :rules="[rules.required]"
                  @blur="onInputBlur"
                ></v-text-field>
         
                
                <v-combobox
                  v-model="item.provincia"
                  name="provincia"
                  item-title="name"
                  item-value="id"
                  :items="provincias"
                  label="Provincia*"
                  autocomplete="off"
                  :disabled="disabled"
                  :rules="[rules.requiredComboBox]"
                  @blur="onInputBlur"
                  clearable
                ></v-combobox>

              </div>
              <div class="col-md-6">
                <v-text-field label="Email" v-model="item.mail" :disabled="disabled" :rules="item.mail ? [rules.email] : []"></v-text-field>

                <v-text-field label="Telefono" v-model="item.phone" :disabled="disabled" :rules="item.phone ? [rules.integer] : []"></v-text-field>

                <div class="row">
                  <div class="col-md-6">
                    <v-text-field 
                      label="Latitud" 
                      v-model="item.lat" 
                      :disabled="disabled"
                      readonly
                    ></v-text-field>
                  </div>
                  <div class="col-md-6">
                    <v-text-field 
                      label="Longitud" 
                      v-model="item.lng" 
                      :disabled="disabled"
                      readonly
                    ></v-text-field>
                  </div>
                </div>

                <Maps 
                  ref="mapaRef"
                  :lat="item.lat" 
                  :lng="item.lng"
                  :address="item.address"
                  :location="item.location"
                  :postal_code="item.postal_code"
                  :provincia="item.provincia"
                  :auto-geocode="true"
                  :disabled="disabled"
                  @coordinates-updated="onCoordinatesUpdated"
                  :height="290"
                />
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading" v-if="!disabled">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { clientService } from "@/libs/ws/clientService";
import { generalService } from "@/libs/ws/generalService";
import Constant from "@/constants/sections";
import ValidMixin from "@/mixins/ValidMixin.vue";
import UserTypeConstant from "@/constants/user_type";
import Maps from "@/components/Maps.vue";
export default {
  mixins: [ValidMixin],
  components: {
    Maps
  },
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
    isClient: Boolean,
    disableClientField: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      disabled: false,
      clients: [],
      loading: false,
      name: "",
      item: {
        id: "",
        name: "",
        mail: "",
        phone: "",
        address: "",
        reference: "",
        external_reference: "",
        location: "",
        postal_code: "",
        provincia: null,
        client: null,
        lat: null,
        lng: null
      },
      defaultItem: null,
      provincias: [],
      user_type: null,
      userTypeConstant: UserTypeConstant
    };
  },
  computed: {},
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = this.formBtn == "";

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.editItem != null && this.editItem.id > 0) {
          this.item = JSON.parse(JSON.stringify(this.editItem));
        } else {
          if (this.defaultItem != null) this.item = JSON.parse(JSON.stringify(this.defaultItem));
          // Si viene un editItem con cliente pre-cargado (aunque id sea 0), usar ese cliente
          if (this.editItem != null && this.editItem.client != null) {
            this.item.client = this.editItem.client;
          }
        }
      }
    },
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    this.loadClients();
    this.loadProvincias();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    onInputBlur() {
      // cuando cualquier input pierde el foco,
      // avisamos al hijo
      this.$refs.mapaRef.handleInputsBlur();
    },
    onCoordinatesUpdated({ lat, lng }) {
      this.item.lat = lat;
      this.item.lng = lng;
    },
    loadProvincias() {
      generalService
        .filter({}, Constant.SECTION_PROVINCIAS)
        .then((response) => {
          this.provincias = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadClients() {
      clientService
        .filter()
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    createItem() {
      if (this.loading) return;

      if (this.valid) {
        this.loading = true;

        const data = {
          id: this.item.id,
          name: this.item.name,
          mail: this.item.mail,
          phone: this.item.phone,
          address: this.item.address,
          provincia: this.item.provincia,
          location: this.item.location,
          postal_code: this.item.postal_code,
          reference: this.item.reference,
          external_reference: this.item.external_reference,
          client: this.item.client,
          lat: this.item.lat,
          lng: this.item.lng,
        };

        if (this.item.id > 0) {
          this.service
            .update(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se modifico correctamente.");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((response) => {
              this.toast.error(response.msg);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.service
            .create(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se creo correctamente");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((e) => {
              this.toast.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>
